import styled from 'styled-components'

const ITStyle = {
	GuideDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 4px;
		background-color: #fff;
		& + & {
			margin-top: 8px;
		}

		& > p {
			${({theme}) => theme.font.extra_small};
			color: ${({theme}) => theme.color.grey4};
		}
	`,
  TableDiv: styled.div`
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid ${({ theme }) => theme.color.grey2};
  `,
	TableDivEvenParticipant: styled.div`
		display: grid;
		grid-template-columns: repeat(${({$showEarly}) => $showEarly ? 5 : 4}, 1fr);
		gap: 25px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			display: flex;
			flex-wrap: wrap;
			border-top: 1px solid ${({theme}) => theme.color.grey2};
			gap: 15px 0px;
		}
	`,
	TableElement: styled.div`
		flex-basis: 50%;
		flex-grow: 1;
		display: flex;
		border-bottom: 1px solid ${({theme}) => theme.color.grey2};

		& > h2 {
			display: flex;
			align-items: center;
			width: 200px;
			min-width: 200px;
			padding: 8px 16px;
			background-color: ${({theme}) => theme.color.grey1};
			${({theme}) => theme.font.extra_small_bold};

			& > span {
				${({theme}) => theme.font.extra_small_bold};
				color: ${({theme}) => theme.color.major};
			}

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				width: 80px;
				min-width: 80px;
				padding: 8px 10px;
			}
		}

		& > .upload-image-container {
			width: 100%;
			background-color: white;
			padding: 8px 16px;
			margin: 6px 6px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 6px;
			height: 250px;
		}

		& > input {
			padding: 8px 16px;
			margin: 6px 6px;
			flex-grow: 1;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}

		& > textarea {
			height: 200px;
			flex-grow: 1;
			${({theme}) => theme.font.extra_small};
			padding: 8px 16px;
			margin: 6px 6px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}

		& > select {
			width: 100%;
			padding: 8px 16px;
			margin: 6px 6px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}
	`,
  TableVerticalElement: styled.div`
    width: 100%;
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.color.grey2};

    & > h2 {
      display: flex;
      align-items: center;
      width: 200px;
      min-width: 200px;
      padding: 8px 16px;
      background-color: ${({ theme }) => theme.color.grey1};
      ${({ theme }) => theme.font.extra_small_bold};

      & > span {
        ${({ theme }) => theme.font.extra_small_bold};
        color: ${({ theme }) => theme.color.major};
      }

      @media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
        width: 200px;
        min-width: 200px;
      }
    }

    & > input {
      width: 100%;
      padding: 8px 16px;
      margin: 6px 6px;
      ${({ theme }) => theme.font.extra_small};
      border: 1px solid ${({ theme }) => theme.color.grey3};
      border-radius: 4px;

      @media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
        margin: 3px 4px;
      }
    }

    input[type="number"]:disabled {
      @media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
        background: #EEF0F2;
        cursor: not-allowed;
      }
    }

    & > select {
      width: 100%;
      padding: 8px 16px;
      margin: 6px 6px;
      ${({ theme }) => theme.font.extra_small};
      border: 1px solid ${({ theme }) => theme.color.grey3};
      border-radius: 4px;

      @media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
        margin: 3px 4px;
      }
    }

    & > textarea {
      height: 200px;
      flex-grow: 1;
      ${({ theme }) => theme.font.extra_small};
      padding: 8px 16px;
      margin: 6px 6px;
      border: 1px solid ${({ theme }) => theme.color.grey3};
      border-radius: 4px;
    }
  `,
	TableSeries: styled.div`
    width: 100%;
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.color.grey2};

    & > h2 {
      display: flex;
      align-items: center;
      width: 200px;
      min-width: 200px;
      padding: 8px 16px;
      background-color: ${({ theme }) => theme.color.grey1};
      ${({ theme }) => theme.font.extra_small_bold};

      & > span {
        ${({ theme }) => theme.font.extra_small_bold};
        color: ${({ theme }) => theme.color.major};
      }

      @media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
        width: 80px;
				min-width: 80px;
				padding: 8px 10px;
      }
    }

    & > input {
      width: 100%;
      padding: 8px 16px;
      margin: 6px 6px;
      ${({ theme }) => theme.font.extra_small};
      border: 1px solid ${({ theme }) => theme.color.grey3};
      border-radius: 4px;

      @media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
        margin: 3px 4px;
      }
    }

    input[type="number"]:disabled {
      @media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
        background: #EEF0F2;
        cursor: not-allowed;
      }
    }
  `,
	TableVerticalElementEvenParticipant: styled.div`
		width: 100%;
		display: flex;
		border-bottom: 1px solid ${({theme}) => theme.color.grey2};
		border-top: 1px solid ${({theme}) => theme.color.grey2};
		${({$isTimer, $isMobile}) => $isTimer && !$isMobile && 'display: none;'}
		& > h2 {
			display: flex;
			align-items: center;
			width: 100px;
			min-width: 100px;
			padding: 8px 16px;
			background-color: ${({theme}) => theme.color.grey1};
			${({theme}) => theme.font.extra_small_bold};

			& > span {
				${({theme}) => theme.font.extra_small_bold};
				color: ${({theme}) => theme.color.major};
			}

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				width: 200px;
				min-width: 200px;
				display: flex;
			}
		}

		& > input {
			width: 100%;
			padding: 8px 16px;
			margin: 6px 6px;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				margin: 3px 4px;
			}
		}

		input[type='number']:disabled {
			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				background: #eef0f2;
				cursor: not-allowed;
			}
		}

		& > select {
			width: 100%;
			padding: 8px 16px;
			margin: 6px 6px;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				margin: 3px 4px;
			}
		}

		& > textarea {
			height: 200px;
			flex-grow: 1;
			${({theme}) => theme.font.extra_small};
			padding: 8px 16px;
			margin: 6px 6px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}
	`,
	SelectWrapper: styled.div`
		position: relative;
		display: flex;
		width: 100%;
		background-color: ${({theme}) => theme.color.grey1};
		width: 190px;
		min-width: 190px;
		margin-right: 12px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			width: 200px;
			min-width: 200px;
			margin-right: 0;
		}

		& > h2 {
			display: flex;
			align-items: center;
			padding: 8px 16px;
			background-color: ${({theme}) => theme.color.grey1};
			${({theme}) => theme.font.extra_small_bold};
			white-space: nowrap;
		}

		select {
			width: 100px;
			padding: 8px 16px;
			margin: 6px 6px;
			${({theme}) => theme.font.extra_small};
			padding-right: 24px;
			appearance: none;
			-webkit-appearance: none;
			-moz-appearance: none;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
			cursor: pointer;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				margin: 3px 4px;
			}
		}

		img {
			position: absolute;
			right: 15px;
			top: 50%;
			transform: translateY(-50%);
			pointer-events: none;
			width: 16px;
			height: 16px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				right: 26px;
			}
		}
	`,
	BtnDefaultContainer: styled.div`
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 4px;
		flex-wrap: wrap;
		margin: 3px 4px;
	`,
	PlusMinusContainer: styled.div`
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 16px;
		margin: 2px 0;
	`,
	Timer: styled.div`
		display: flex;
		align-items: center;
		width: 200px;
		min-width: 200px;
		padding: 8px 16px;
		background-color: ${({theme}) => theme.color.grey1};
		${({theme}) => theme.font.extra_small_bold};

		& > span {
			${({theme}) => theme.font.extra_small_bold};
			color: ${({theme}) => theme.color.major};
		}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			width: 66px;
			min-width: 66px;
		}
	`,
}

export default ITStyle
